module.exports = "<div class=\"avatar\" [ngStyle]=\"getMyStyle()\">\n  <img [src]=\"image\" alt=\"\" />\n</div>\n"